/** Знак обрыва: им отмечено и усечённое значение, и ушедший из строки хвост описания */
export const TRUNCATION_ELLIPSIS = '…';

/**
 * Укорачивает значение до предела в знаках, отмечая обрыв многоточием. Обрыв отмечается самим
 * текстом, а не оформлением: на тесной ступени под многоточие места в разметке уже не остаётся,
 * и оно молча пропадает — тогда обрубленное значение читается как целое.
 *
 * `null` — предела нет, значение возвращается как есть.
 */
export const shortenValue = (text: string, limitChars: number | null): string => {
  if (limitChars === null || text.length <= limitChars) return text;
  return `${text.slice(0, limitChars).trimEnd()}${TRUNCATION_ELLIPSIS}`;
};
